
import { Component, Vue } from 'vue-property-decorator';
import { container } from '../../lib/container';
import { AppBehavior } from '../../lib/core/AppBehavior';

const behavior = container.get<AppBehavior>('behavior');

@Component
export default class WelcomeSide extends Vue {
	get showBadges(): boolean {
		return behavior.appView == false;
	}
}
